<template lang="html">
  <v-layout column wrap justify-center align-center v-if="progress">
    <v-progress-circular :size="80" :width="8" color="primary" :indeterminate="progress"></v-progress-circular>
  </v-layout>
  <v-layout column wrap justify-start align-center v-else>
    <div class="div-right">
      <v-btn color="primary" icon flat @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-layout column wrap justify-center align-center>
      <v-avatar
        size="80"
      >
      <img v-if="infor_bot.user.profilepicture" :src="infor_bot.user.profilepicture">
      <img v-else src="/static/img/default_profile/bot-white.png">
      </v-avatar>
      <div class="mt-3 div-center">
        <h3 class="text2">{{infor_bot.user.nickname}}</h3>
      </div>
      <v-btn dark color="primary" class="mt-4" round v-if="infor_bot.relation === 'unknow' || infor_bot.relation === 'unfriend' || infor_bot.relation === 'unknown'" @click="addFriend()">
        <span>{{relation}}</span>
      </v-btn>
      <v-btn dark color="red" class="mt-4" round v-else-if="infor_bot.relation === 'block'" @click="unBlock()">
        <span>{{relation}}</span>
      </v-btn>
      <v-btn dark color="primary" class="mt-4" round v-if="infor_bot.relation === 'friend'" @click="Chat()">
        <span>{{relation}}</span>
      </v-btn>

        <v-dialog v-model="dialogPassword" max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t('LeftSide.addFiend.headerCheckpass')}}
              <v-spacer></v-spacer>
              <v-btn icon @click="close_dialog_pass">
                <v-icon style="color: black !important; font-size: 25px !important;">clear</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-text-field
                @keyup.enter.exact="check_password_bot"
                solo
                :label="$t('LeftSide.addFiend.placeholderPassword')"
                v-model="password"
                clearable
                hide-details
                >
              </v-text-field>
              <span style="color: red; padding-left: 10px;">{{message_error}}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="clear_dialog_pass" class="btncancle">
                {{$t('AnswerQuestion.clear')}}
              </v-btn>

              <v-btn @click="check_password_bot" class="btnaddfriend" :loading="loading">
                {{$t('AnswerQuestion.addFriend')}}
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      progress: false,
      decoded: '',
      infor_bot: {},
      relation: '',
      tokenuser: '',
      dialogPassword: false,
      loading: false,
      password: '',
      message_error: '',
      windowWidth: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    this.windowWidth = window.innerWidth
    this.decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = this.decoded.tokenuser
    this.searchFriend(this.$route.params.botid)
  },
  methods: {
    searchFriend (botid) {
      this.progress = true
      this.axios.post(process.env.APIsearchfriend, {
        tokenbot: botid,
        tokenuser: this.tokenuser
      }).then((response) => {
        this.progress = false
        // console.log(response.data.listuser)
        if (response.data.listuser) {
          localStorage.removeItem('botid_redirect')
          this.infor_bot = response.data.listuser
          // console.log(`obj: ${this.infor_bot.relation}`)
          if (this.infor_bot.relation === 'unknow' || this.infor_bot.relation === 'unfriend' || this.infor_bot.relation === 'unknown') {
            this.relation = 'เพิ่มเพื่อน'
            // console.log(`re: ${this.relation}`)
          } else if (this.infor_bot.relation === 'block') {
            this.relation = 'ยกเลิกบล็อค'
          } else if (this.infor_bot.relation === 'friend') {
            this.relation = 'แชท'
            // if (this.windowWidth <= 960) {
            //   this.$router.push('/mobile/room/' + response.data.tokenroom)
            // } else {
            //   this.$router.push('/chat/room/' + response.data.tokenroom)
            // }
          }
        } else {
          this.progress = false
          if (this.windowWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        }
      }).catch(error => {
        this.progress = false
        console.log(error)
      })
    },
    check_password_bot () {
      this.message_error = ''
      this.loading = true
      this.axios.post(process.env.APImanage + '/check_password_bot', {
        tokenBot: this.infor_bot.user.tokenuser,
        password: this.password
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            this.axios.post(process.env.APInew_addfriend, {
              tokenfriend: this.infor_bot.user.tokenuser,
              tokenuser: this.tokenuser
            }).then((response) => {
              if (response.data.status === 'success') {
                this.dialogPassword = false
                this.loading = false
                this.password = ''
                if (this.windowWidth <= 960) {
                  this.$router.push('/mobile/room/' + response.data.tokenroom)
                } else {
                  this.$router.push('/chat/room/' + response.data.tokenroom)
                }
              }
            })
          } else {
            this.loading = false
            this.message_error = this.$t('LeftSide.addFiend.messageCheckbot')
            // console.log(response.data.message)
          }
        }
      })
    },
    clear_dialog_pass () {
      this.message_error = ''
      this.password = ''
    },
    close_dialog_pass () {
      this.dialogPassword = false
      this.message_error = ''
      this.password = ''
    },
    close () {
      // ถ้ามีค่า bot redirect url แต่ปิด dialog add friend จะลบค่าออก
      // เวลาเข้าห้องแชทจะไม่มีการแสดง webview
      if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        localStorage.removeItem('botid_redirect_url')
      }
      this.progress = true
      if (this.windowWidth <= 960) {
        this.progress = false
        this.$router.push('/mobile/homepage')
      } else {
        this.progress = false
        this.$router.push('/chat')
      }
    },
    addFriend () {
      console.log('add friend')
      if (this.infor_bot.user.is_password !== '0') {
        console.log('is_password')
        this.dialogPassword = true
        // this.infor_bot = { 'tokenbot': tokenfriend, 'index': index }
      } else {
        this.axios.post(process.env.APInew_addfriend, {
          tokenfriend: this.infor_bot.user.tokenuser,
          tokenuser: this.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            if (this.windowWidth <= 960) {
              this.$router.push('/mobile/room/' + response.data.tokenroom)
            } else {
              this.$router.push('/chat/room/' + response.data.tokenroom)
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    unBlock () {
      this.$swal({
        title: 'คุณแน่ใจหรือไหม?',
        text: 'เรากำลังยกเลิกการบล็อค ' + this.infor_bot.user.name + ' !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/unblockfriend', {
            tokenfriend: this.infor_bot.user.tokenuser,
            tokenuser: this.tokenuser,
            tokenroom: this.infor_bot.user.tokenroom }).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                'ยกเลิกการบล็อคสำเร็จ.',
                'success'
              )
              this.infor_bot.relation = 'friend'
              this.relation = 'แชท'
            }
          })
        }
      })
    },
    Chat () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/room/' + this.infor_bot.user.tokenroom)
      } else {
        this.$router.push('/chat/room/' + this.infor_bot.user.tokenroom)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.text2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.div-center {
  justify-content: center;
  display: flex;
  width: 107px;
  align-items: center;
}
.div-right {
  justify-content: end;
  width: 100%;
  align-items: end;
  display: grid;
}
.btncancle {
  /* border-style: solid !important; */
  background-color: #eee !important;
  border-radius: 30px !important;
  color: #27303e !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
  border-color: white !important;
}
.btnaddfriend {
  /* border-style: solid !important; */
  background-color: #1976d2 !important;
  border-radius: 30px !important;
  color: white !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
}
>>> .cyan {
  background-color: white !important;
  border-color: white !important;
}
>>> .v-input__slot {
  border-width: thin !important;
  border-color: #777777d1 !important;
  border-style: solid !important;
  border-radius: 20px !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/AddBot.vue